<div class="p-grid">
  <div class="p-col-10 m-auto p-mt-5">
    <p>
      {{'HISTORIA.HEADER.TEXTO1' | translate}}
    </p>
    <div class="p-grid p-mt-1">

      <p-card class="p-xl-4 p-lg-12 p-md-12 p-sm-12 c" header="{{'HISTORIA.ANTECEDENTES.TITULO' | translate}}">
        <img src="assets/imagenes/zona carga y descarga 3.jpg" alt="{{'HISTORIA.ANTECEDENTES.TITULO' | translate}}"
          class="img" />
        <p>{{'HISTORIA.ANTECEDENTES.TEXTO1' | translate}}</p>
        <p>{{'HISTORIA.ANTECEDENTES.TEXTO2' | translate}}</p>
        <p class="npb">{{'HISTORIA.ANTECEDENTES.TEXTO3' | translate}}</p>
      </p-card>

      <p-card class="p-xl-4 p-lg-12 p-md-12 p-sm-12 c" header="{{'HISTORIA.ORA.TITULO' | translate}}">
        <a class="scale" href="http://valladolidora.com/es" target="_blank">
          <img src="assets/imagenes/VAORA_Logo.jpg" alt="{{'HISTORIA.ORA.TITULO' | translate}}" class="img" />
        </a>
        <p>{{'HISTORIA.ORA.TEXTO1' | translate}}</p>
        <p>{{'HISTORIA.ORA.TEXTO2' | translate}}</p>
        <p><b class="blue">{{'HISTORIA.ORA.TEXTO3P' | translate}}</b>{{'HISTORIA.ORA.TEXTO3' | translate}}</p>
        <p><b class="orange">{{'HISTORIA.ORA.TEXTO4P' | translate}}</b>{{'HISTORIA.ORA.TEXTO4' | translate}}</p>
        <p><b class="green">{{'HISTORIA.ORA.TEXTO5P' | translate}}</b>{{'HISTORIA.ORA.TEXTO5' | translate}}</p>
        <p class="npb"><b class="grey">{{'HISTORIA.ORA.TEXTO6P' | translate}}</b>{{'HISTORIA.ORA.TEXTO6' | translate}}</p>
      </p-card>
      <p-card class="p-xl-4 p-lg-12 p-md-12 p-sm-12 c" header="{{'HISTORIA.OTRAS.TITULO' | translate}}">
        <img src="assets/imagenes/ENCUESTA_VE.png" alt="{{'HISTORIA.OTRAS.TITULO' | translate}}" class="img">
        <p class="npb">{{'HISTORIA.OTRAS.TEXTO1' | translate}}</p>
      </p-card>
    </div>
  </div>
</div>